<template>
  <ul class="mobile-side-menu">
    <slot name="header" />
    <li v-for="node in getNav" :key="'mobile'+node.id">
      <span v-if="node.menus.length > 0" class="mmenu-toggle" />
      <a :href="$catLink(node.seo_link)">{{ node.name }}</a>
      <ul>
        <li v-for="subnode in node.menus"
            :key="'mobile'+subnode.id">
          <span v-if="subnode.menus.length > 0" class="mmenu-toggle" />
          <a :href="$catLink(subnode.seo_link)">{{ subnode.name }}</a>
          <ul v-if="subnode.menus.length > 0">
            <li v-for="submenu in getLimited(subnode.menus)"
                :key="'mobile'+submenu.id">
              <a :href="$catLink(submenu.seo_link)">{{submenu.name }}</a>
            </li>
            <li v-if="subnode.menus.length > 5">
              <a :href="$catLink(subnode.seo_link)">
                <strong>View all {{subnode.name }}...</strong>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <slot name="footer"/>
  </ul>
</template>

<script>
  import MobileNavMain from "^/top-level/mobile-nav-main"
  export default {
    name: "mobile-nav-main",
    extends:MobileNavMain
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/gunoldcan/src/vue-src/top-level/mobile-nav-main.vue